import { useEffect, useState } from "react";
import { Col, Container, Row, Nav, Button, Offcanvas, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCaretDown, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Tabs, Menu } from "antd";
import { ApartmentOutlined, AppstoreOutlined, BankOutlined, BarChartOutlined, BuildOutlined, CompassOutlined, ExperimentOutlined, HomeOutlined, InfoCircleOutlined, MailOutlined, PhoneOutlined, ProjectOutlined, SettingOutlined, ShopOutlined } from '@ant-design/icons';
import logo from '../../assets/images/ParkHeightsLogo.webp';

// 1. Import HashLink instead of the regular Link
import { HashLink } from 'react-router-hash-link';

const mobileMenuItems = [
    { key: 'home', icon: <HomeOutlined />, label: 'Home' },
    { key: 'overview', icon: <InfoCircleOutlined />, label: 'Overview' },
    { key: 'architecture', icon: <BuildOutlined />, label: 'Architecture' },
    { key: 'greenery', icon: <ExperimentOutlined />, label: 'Greenery' },
    { key: 'clubhouse', icon: <AppstoreOutlined />, label: 'Clubhouse' },
    { key: 'location', icon: <CompassOutlined />, label: 'Location' },
    { key: 'contact', icon: <PhoneOutlined />, label: 'Contact Us' }, // Future-proofed
];



// Helper function for the accordion logic you provided
const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
        items2.forEach(item => {
            if (item.key) key[item.key] = level;
            if (item.children) func(item.children, level + 1);
        });
    };
    func(items1);
    return key;
};

const levelKeys = getLevelKeys(mobileMenuItems);

const ParkHeightsHeader = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
    const [currentPath, setCurrentPath] = useState(location.pathname);
    // const [isResidentialDropdownOpen, setIsResidentialDropdownOpen] = useState(false);
    // const [isCommercialDropdownOpen, setIsCommercialDropdownOpen] = useState(false);
    // const [isSpaceDropdownOpen, setIsSpaceDropdownOpen] = useState(false);
    
    const [showSideNav, setShowSideNav] = useState(false);
    const [stateOpenKeys, setStateOpenKeys] = useState(['residential']);

    const handleClose = () => setShowSideNav(false);
    const handleShow = () => setShowSideNav(true);

    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
    // Only close if the actual URL path has changed
    if (location.pathname !== currentPath) {
        setIsProjectsDropdownOpen(false);
        setShowSideNav(false);
        setCurrentPath(location.pathname); // Update the path tracker
    }
}, [location.pathname, currentPath]);

    const toggleProjects = (e) => {
        e.stopPropagation();
        setIsProjectsDropdownOpen(!isProjectsDropdownOpen);
        // setIsResidentialDropdownOpen(false);
        // setIsCommercialDropdownOpen(false);
        // setIsSpaceDropdownOpen(false);
    }
    
    
    const onOpenChange = (openKeys) => {
        const currentOpenKey = openKeys.find(key => !stateOpenKeys.includes(key));
        if (currentOpenKey !== undefined) {
            const repeatIndex = openKeys
                .filter(key => key !== currentOpenKey)
                .findIndex(key => levelKeys[key] === levelKeys[currentOpenKey]);
            setStateOpenKeys(
                openKeys
                    .filter((_, index) => index !== repeatIndex)
                    .filter(key => levelKeys[key] <= levelKeys[currentOpenKey]),
            );
        } else {
            setStateOpenKeys(openKeys);
        }
    };

    const handleScroll = () => {
        const offset = window.scrollY;
        if(offset > 100){
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    return (
        <Container fluid className={`header w-100 ${scrolled ? 'header-sticky' : ''} p-0`}>
            <Row className="main-nav-row">
                <Col xs={4} md={4} lg={2} className="logo-holder">
                    <Link to='/cpr-park-heights'>
                        {/* <h5>Logo</h5> */}
                        <Image src={logo} style={{width: '100px'}}/>
                    </Link>
                </Col>
                <Col md={7} className="nav-bar-holder d-none d-lg-block">
                    <Nav className="nav-bar">
                        <HashLink className="link" to='#hero'>Home</HashLink>
                        <HashLink className="link" to='#overview'>Overview</HashLink>
                        <HashLink className="link" to='#architecture'>Architecture</HashLink>
                        <HashLink className="link" to='#greenery'>Greenery</HashLink>
                        <HashLink className="link" to='#clubhouse'>Clubhouse</HashLink>
                        <HashLink className="link" to='#location'>Location</HashLink>
                        <HashLink className="link" to='#contact'>Contact Us</HashLink>
                    </Nav>
                </Col>
                
                {/* --- NEW: PHONE NUMBERS (Visible only on Desktop for better layout) --- */}
                <Col lg={2} className="header-phone-col d-none d-lg-flex justify-content-center border-start border-end border-light px-3">
                    <div className="header-contact-info text-start">
                        <div className="d-flex flex-column">
                            <a href="tel:+919908788633" className="header-phone-link link">
                                <FontAwesomeIcon icon={faPhone}/> +91 99087 88633
                            </a>
                        </div>
                    </div>
                </Col>

                <Col xs={8} md={8} lg={1} className="offcanvas-toggle-holder d-flex justify-content-end align-items-center">
                    <Button 
                        variant="none"
                        className="menu-icon"
                        onClick={() => handleShow()}
                    >
                        <FontAwesomeIcon icon={faBars}/>
                    </Button>
                </Col>
            </Row>
            <Row className="offcanvas">
                <Offcanvas show={showSideNav} onHide={handleClose} placement="end">
                    <Offcanvas.Header closeButton />
                    <Offcanvas.Body>
                        <Menu 
                            mode="inline"
                            openKeys={stateOpenKeys}
                            onOpenChange={onOpenChange}
                            items={mobileMenuItems}
                            style={{width: '100%', borderRight: 'none'}}
                            onClick={({key}) => {
                                handleClose();

                                // This ensures the scroll works smoothly on the landing page
                                if (location.pathname === '/' || location.pathname === '/home') {
                                    window.location.hash = `#${key}`;
                                } else {
                                    // Sends them back to the landing page first if they are on another page
                                    navigate(`/#${key}`);
                                }
                            }}
                        />
                    </Offcanvas.Body>
                </Offcanvas>
            </Row>
        </Container>
    );
}

export default ParkHeightsHeader;